import Container from './../dom/Container';
import GridItem from './../components/GridItem';
import { EPGUtil } from './../../../Nepg/EPGUtil';
import EpgConstants from './../../../Nepg/EpgConstants';
import { unmount } from 'redom';
import Utils from '../../../../utils/Utils';
import EpgPersistence from '../../../Nepg/EpgPersistence';
export default class GridRow extends Container {

    constructor(elementParent, attrs, channelList, index) {
        super(elementParent, attrs);
        this.eventsList = [];
        this.items = [];
        this.channelList = channelList;
        this.parentIndex = index;

        // El tiempo de la ventana 
        // actualmente en pantalla, TODO en SEGUNDOS
        this.timeWindowStart = null;
        this.timeWindowEnd = null;
        this.timeWindowLength = null;

        this.gridWidth = 0;

        this.left = null;
        this.top = null;

        this.horizontalSpaceBetweenItems = EpgConstants.HORIZONTAL_SPACE_BETWEEN_ITEMS;
        this.setGetDirection = this.setGetDirection.bind(this);
        this.getDirection = this.getDirection.bind(this);
        this.cleanClassSlide = this.cleanClassSlide.bind(this);
        this.cbDirection = null;

        this.itemsCache = [];
    }

    setGetDirection(cb) {
        this.cbDirection = cb;
    }

    getDirection() {
        return (typeof this.cbDirection === 'function' && this.cbDirection()) || '';
    }

    setTop(top) {
        this.top = top;
        this.rootElement.style.top = top + 'px';
    }

    getTop() {
        return this.top;
    }

    setLeft(left) {
        this.left = left;
        this.rootElement.style.left = left + 'px';
    }

    getLeft() {
        return this.left;
    }

    setTimeWindowStart(time) {
        this.timeWindowStart = time;
    }

    setTimeWindowEnd(time) {
        this.timeWindowEnd = time;
    }

    setTimeWindowLength(time) {
        this.timeWindowLength = time;
    }

    setData(events) {
        this.eventsList = events;
    }

    getData(events) {
        return this.eventsList;
    }

    getItems() {
        return this.items;
    }

    getDataItemAtIndex(idx) {
        return this.eventsList && typeof this.eventsList[idx] !== 'undefined' ? this.eventsList[idx] : null;
    }

    setGridWidth(width) {
        this.gridWidth = width;
    }

    getGridWidth() {
        return this.gridWidth ? this.gridWidth : this.getRootElement().offsetWidth;
    }

    getWidth() {
        return this.getGridWidth();
    }

    getHeight() {
        const defaultRowHeight = EpgConstants.VERTICAL_ROW_HEIGHT;

        return defaultRowHeight;
    }

    setCacheItems(cache) {
        this.itemsCache = cache;
    }

    setItems(items) {
        this.items = items;
    }

    empty() {
        if (this.items.length > 0) {
            for (var i = 0, len = this.items.length; i < len; i++) {
                this.items[i].destroyParentReference();
                let unItem = this.items[i];
                unmount(this.getRootElement(), this.items[i].getRootElement());
            }
            this.items = [];
        }
    }

    destroy() {
        if (this.items.length > 0) {
            for (var i = 0, len = this.items.length; i < len; i++) {
                this.items[i].destroy();
            }
            this.items = [];
        }
    }

    changeParent(item, idx) {
        let itemParent = item.getParent();
        if (itemParent) {
            let parentItems = itemParent.getItems();
            if (Array.isArray(parentItems) && parentItems.length > 0) {
                for (let i = parentItems.length - 1; i >= 0; i--) {
                    if (item === parentItems[i]) {
                        parentItems.splice(i, 1);
                    }
                }
            }
            unmount(itemParent.getRootElement(), item.getRootElement());
            item.destroyParentReference();
        }
        this.addChild(item);
    }

    draw() {
        this.destroy();
        let itemLeftOffset = 0; // Acumulador offset, left
        let gridItem;
        let defEventHeight = this.getHeight();
        let defEventWidth = this.getWidth();

        if (this.eventsList && this.eventsList.length > 0) {

            // window.NEPG_GEFULLITEM = window.performance.now();
            for (let i = 0, len = this.eventsList.length; i < len; i++) {

                if (this.itemsCache[i]) {
                    if (!EPGUtil.enableNativeAnimation()) {
                        this.cleanClassSlide(this.itemsCache[i]);
                    }
                    this.itemsCache[i].hightlightOff();

                    this.changeParent(this.itemsCache[i]);
                    this.items.push(this.itemsCache[i]);

                    continue;
                }

                let eventData = this.eventsList[i];
                if (EPGUtil.isValidEvent(eventData)) {
                    let eventWidth = EPGUtil.getEventGridWidth(
                        eventData.date_begin,
                        eventData.date_end,
                        this.timeWindowStart,
                        this.timeWindowLength,
                        this.gridWidth,
                        this.horizontalSpaceBetweenItems
                    );
                    // window.NEPG_GETWIDTH = window.performance.now();
                    gridItem = this.getGridEvent(eventData, itemLeftOffset, eventWidth, defEventHeight);
                    itemLeftOffset = itemLeftOffset + this.horizontalSpaceBetweenItems + eventWidth;
                }
                else {
                    gridItem = this.getEmptyEvent(defEventWidth, defEventHeight);
                }
                this.items.push(gridItem);
            }
        }
        else {
            gridItem = this.getEmptyEvent(defEventWidth, defEventHeight);
            this.items.push(gridItem);
        }
    }

    cleanClassSlide = (item) =>{
        if(item && item.rootElement && item.rootElement.classList && (typeof item.rootElement.classList.remove === 'function')){
            item.rootElement.classList.remove('__slideInRight');
            item.rootElement.classList.remove('__slideInLeft');
        }
    }

    getRandomBgColor() {
        var x1 = Math.floor(Math.random() * 256);
        var x2 = Math.floor(Math.random() * 256);
        var x3 = Math.floor(Math.random() * 256);
        var bgColor = "rgb(" + x1 + "," + x2 + "," + x3 + ")";

        return bgColor;
    }

    getGridEvent(eventData, left, width, height) {
        // window.NEPG_GETWIDTH2 = window.performance.now();
        let style = {
            position: 'absolute',
            top: '0px',
            left: left + 'px',
            width: width + 'px',
            height: height + 'px',
            //backgroundColor: this.getRandomBgColor()
        };

        let gridEvent = new GridItem(this,null,this.channelList);
        gridEvent.setNativeAnimation(EPGUtil.enableNativeAnimation());
        // Primero settear data, luego
        gridEvent.setData(eventData);

        gridEvent.setStyle(style, this.getDirection());
        gridEvent.addClassName('event-list-item');

        // ANIMACION IZQUIERDA Y DERECHA PARA FULL EPG.
        if (Utils.playerEnableAnimation() && !EPGUtil.enableNativeAnimation()) {
            if (this.getDirection() === 'RIGHT') {
                gridEvent.removeClassName('__slideInLeft');
                gridEvent.removeClassName('__slideInRight');
                gridEvent.addClassName('__slideInRight');
            }
            if (this.getDirection() === 'LEFT') {
                gridEvent.removeClassName('__slideInRight');
                gridEvent.removeClassName('__slideInLeft');
                gridEvent.addClassName('__slideInLeft');
            }
        }
        gridEvent.setWidth(width);
        //console.log('[NEPGPERF] ROW BUILD  > gridItem getGridEvent1> ' + eventData.name + ': ' + (window.performance.now() - window.NEPG_GETWIDTH2));

        // window.NEPG_GETWIDTH3 = window.performance.now();

        //console.log('[STYL] GridEvent ', style);

        gridEvent.display();
        //console.log('[NEPGPERF] ROW BUILD  > gridItem getGridEvent2 display> ' + eventData.name + ': ' + (window.performance.now() - window.NEPG_GETWIDTH3));

        return gridEvent;
    }

    isGridIncomplete() {
        if(this.channelList && this.channelList.isGridIncomplete && typeof this.channelList.isGridIncomplete == 'function' && !isNaN(this.parentIndex)){
            const currentIndex = parseInt(this.parentIndex) + 1;
            return this.channelList.list && Array.isArray(this.channelList.list) && currentIndex > this.channelList.list.length && this.channelList.isGridIncomplete();
        }
        return false;
    }


    getEmptyEvent(width, height) {
        let style = {
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: width + 'px',
            height: height + 'px'
        };

        let emptyItem = new GridItem(this);
        emptyItem.setStyle(style);
        emptyItem.addClassName('event-list-item');
        emptyItem.setData({
            name: this.isGridIncomplete() ? ' ' : EpgPersistence.getLabelNotAvailable(),
        });
        emptyItem.display();

        return emptyItem;
    }

    getItemWidth(eventStartTime, eventEndTime) {
        let timeWindowStart = this.timeWindowStart * 1000;

    }

    hideItems() {
        if (this.items.length > 0) {
            for (var i = 0, len = this.items.length; i < len; i++) {
                this.items[i].hide();
            }
        }
    }

    showItems() {
        if (this.items.length > 0) {
            for (var i = 0, len = this.items.length; i < len; i++) {
                this.items[i].show();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/AAF/lib/gui/components/GridRow.js